import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import config from 'src/config';
import { rateLimitErrorLink } from './rateLimitErrorLink';
// import { initGraphQLTada } from '@tada/gql';
// import { introspection } from './generated/introspection';

const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

const httpLink = new HttpLink({
  uri: [config.REACT_APP_API_URL, 'webshop'].join('/')
});

const cache = new InMemoryCache();

export const apolloClient = new ApolloClient({
  // rateLimitErrorLink first so a RATE_LIMITED / IP_BLOCKED denial is toasted before the
  // generic console logging; CAPTCHA_REQUIRED is deliberately not handled here.
  link: from([rateLimitErrorLink, errorLink, httpLink]),
  cache
});

// export const graphql = initGraphQLTada<{
//   introspection: introspection
// }>()

